<script type="text/javascript">
	import SparkMD5 from 'spark-md5'
	import axios from 'axios'
	export default {
		checkImg(filedata,file,name,checkurl,uploadurl,func){ 	
			let url=checkurl+SparkMD5.hashBinary(filedata);
			console.log(url);
	    	axios.post(url).then((res)=>{
				console.log(res);
	    		if(res == false || (res.state.value == 0 && res.result == null)){
	    			this.uploadImg(file,name,uploadurl,func);	    			 
	    		}else{
	    			func({state:1,msg:res.result.ossUrl,id:res.result.id});
	    		} 	    		
	    	})
	    	// .catch((err)=>{
	    	// 	func({state:0,msg:"验证md5网络异常"});
	    	// })
	    },
	    uploadImg(file,name,uploadurl,func){
	    	let formData = new FormData();
	    	formData.append('file',file);
	    	formData.append('filename',name);  
	    	let config = {
	    		headers:{'Content-Type':'multipart/form-data'}
	    	}
	    	axios.post(uploadurl,formData,config).then((res)=>{
	    		if(res.state.value ==0){ 
	    			// console.log(res);
	    			func({state:1,msg:res.result.ossUrl,id:res.result.id});
	    		}else{	    			 
	    			func({state:0,msg:res.state.name});
	    		}
	    	})
	    	.catch((err)=>{
	    		func({state:0,msg:"uploadimg网络异常"});
	    	})
	    }
	}
</script>


// WEBPACK FOOTER //
// src/common/upload.vue